"use client";
import { ProcessedCourse } from "@/common/course/types";
import CourseSnapshot from "./CourseSnapshot";
import MonarchResolver from "@/monarch/MonarchResolver";
import { useMonarchData } from "@/monarch/MonarchResolver";
import type {
  CertificateFactoid,
  ExecEdPromoHighlight,
} from "@/monarch/rules/execEdPromoHighlight/types";

interface CourseSnapshotComponentProps {
  course: ProcessedCourse;
  paymentOption: string | null;
  className?: string;
  hasDateColumn?: boolean;
  isArchivedExternally?: boolean;
  certificateFactoid?: CertificateFactoid;
}

function CourseSnapshotWithPromoHighlight(props: CourseSnapshotComponentProps) {
  const promoTestData = useMonarchData<ExecEdPromoHighlight>(
    "useExecPromoHighlight",
  );

  const promoData = promoTestData?.data;

  const certificateFactoid = promoData?.certificateFactoid;

  return <CourseSnapshot {...props} certificateFactoid={certificateFactoid} />;
}

function CourseSnapshotWithoutPromoHighlight(
  props: CourseSnapshotComponentProps,
) {
  const { certificateFactoid } = props;
  return <CourseSnapshot {...props} certificateFactoid={certificateFactoid} />;
}

export default function ExecEdPromoHeroClient(
  props: CourseSnapshotComponentProps,
) {
  return (
    <MonarchResolver<ExecEdPromoHighlight>
      experimentKey="useExecPromoHighlight"
      variants={{
        control: <CourseSnapshotWithoutPromoHighlight {...props} />,
        controlEEPromoHighlight: (
          <CourseSnapshotWithoutPromoHighlight {...props} />
        ),
        execEdPromoBannerAndHighlightBoth: (
          <CourseSnapshotWithPromoHighlight {...props} />
        ),
        execEdPromoBannerAndHighlightOnlyHighlight: (
          <CourseSnapshotWithPromoHighlight {...props} />
        ),
        heroBanner: <CourseSnapshotWithoutPromoHighlight {...props} />,
      }}
      fallbackVariant="control"
    />
  );
}
